'use client'
import React, { ReactNode } from 'react'
import { motion } from 'motion/react'
import Navbar from './NavBar/Navbar';
import Footer from './Footer/Footer';

interface Props {
    children: ReactNode;
    navBar?: ReactNode;
    footer?: ReactNode;
}

const PageWrapper = ({children, navBar = null, footer = null}: Props) => {
  return (
    <div>
        {navBar == null ? <Navbar /> : navBar}
        <motion.main
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4 }}
        >
          {children}
        </motion.main>
        {footer == null ? <Footer /> : footer}
    </div>
  )
}

export default PageWrapper
